export class ProductCard extends HTMLElement {
  connectedCallback() {
    this.infoButton = this.querySelector('[data-info-button]');
    this.infoOverlay = this.querySelector('[data-info-overlay]');
    this.closeButton = this.querySelector('[data-close-button]');
    this.fadeOverlay = this.querySelector('.overlay-fade-overlay');

    this.infoButton.addEventListener('click', this.showOverlay.bind(this));
    this.closeButton.addEventListener('click', this.hideOverlay.bind(this));

    this.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  showOverlay() {
    this.infoOverlay.classList.remove('opacity-0', 'invisible');
    this.infoOverlay.classList.add('opacity-100', 'visible');
    this.infoOverlay.setAttribute('aria-hidden', 'false');
    this.infoOverlay.classList.remove('scale-95');
    this.infoOverlay.classList.remove('rounded-2xl');
    this.infoOverlay.classList.remove('translate-y-12');
  }

  hideOverlay() {
    this.infoOverlay.classList.remove('opacity-100', 'visible');
    this.infoOverlay.classList.add('opacity-0', 'invisible');
    this.infoOverlay.setAttribute('aria-hidden', 'true');
    this.infoOverlay.classList.add('scale-95');
    this.infoOverlay.classList.add('rounded-2xl');
    this.infoOverlay.classList.add('translate-y-12');
  }

  handleOutsideClick(event) {
    if (event.target === this.infoOverlay) this.hideOverlay();
  }

  disconnectedCallback() {
    this.infoButton.removeEventListener('click', this.showOverlay.bind(this));
    this.closeButton.removeEventListener('click', this.hideOverlay.bind(this));
    this.removeEventListener('click', this.handleOutsideClick.bind(this));
  }
}

customElements.define('product-card', ProductCard);
